import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSkip5SecondsBackward32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSkip5SecondsBackward32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M20.465 6.543a1 1 0 0 0-1.415 0l-4.242 4.243a1 1 0 0 0 0 1.414l4.242 4.242a1 1 0 0 0 1.415-1.414l-2.536-2.535H23a3 3 0 0 1 3 3v5.5a3 3 0 0 1-3 3h-6a1 1 0 0 0 0 2h6a5 5 0 0 0 5-5v-5.5a5 5 0 0 0-5-5h-5.071l2.536-2.536a1 1 0 0 0 0-1.414M9.5 17.993A2.01 2.01 0 0 1 7.5 20c-.526 0-.98-.176-1.316-.368a3 3 0 0 1-.468-.331l-.015-.014a1 1 0 0 0-1.408 1.42L5 20l-.707.708.002.001.003.003.006.006.018.017a3 3 0 0 0 .233.202c.15.12.365.276.636.431A4.66 4.66 0 0 0 7.5 22c2.216 0 3.983-1.796 4-3.992C11.514 16.16 10.262 14 8 14c-.79 0-1.458.134-2 .316v-2.299h3.5a1 1 0 1 0 0-2H4V16a1 1 0 0 0 1.697.717l.008-.007q.02-.019.082-.066c.083-.062.22-.154.41-.25C6.575 16.206 7.173 16 8 16c.738 0 1.509.79 1.5 1.992"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSkip5SecondsBackward32);
